import { ActionsContent } from './utils/ActionsContent';
import PropTypes from 'prop-types';
import { useItems } from './utils/ItemsContext';
import { cache } from '../../App';
import { updateStream } from '@utils/graphql/creators/streams';
import { getLogger } from '@utils/general';
import { notifications } from '@utils/notifications/index';

const logger = getLogger('src.pages.split.streams.bulkUpdate');

export const OnlineOffline = ({ title, online }) => {
  const { streams } = useItems();

  return (
    <ActionsContent
      title={title}
      description={
        `Once updated, selected streams will be set to ${online
          ? 'Online to enable users to view the streams'
          : 'Offline to block users from viewing the streams'}.`
      }
      confirmAction={() => {
        if (!streams.length) {
          const warn = 'No items selected for bulk action.';
          notifications.warn(warn);
          logger.warn(warn);
          return;
        }

        // Store the bulk operation info in cache
        cache.set('bulkOperationCount', {
          total: streams.length,
          completed: 0,
          successes: 0,
          failures: 0,
          failedStreams: [],
        });

        streams.forEach((stream) => {
          const streamInfo = { id: stream.id, name: stream.name };
          updateStream('update_stream', stream.id, { online: online }, true, streamInfo).execute();
        });
      }}
      confirmBtnState={streams.length > 0 ? 'default' : 'disabled'}
    />
  );
};

OnlineOffline.propTypes = {
  title: PropTypes.string.isRequired,
  online: PropTypes.bool.isRequired,
};